import React from 'react';

export interface IProps {
  fillColor?: string;
}

const StarIcon: React.FC<IProps> = (props) => {
  return (
    <svg width="46" height="49" viewBox="0 0 46 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="m22 0 5.164 16.93h16.71L30.355 27.391 35.52 44.32 22 33.858 8.48 44.321l5.165-16.93L.125 16.93h16.711L22 0z" fill={props.fillColor ?? "#FFD84D"}/>
    </svg>
  )
}

export default StarIcon;